<template>
  <v-dialog
      persistent
      v-model="showWindow"
      scrollable
      max-width="550"
      max-height="90%"
      min-width="90%"
  >
    <v-card height="100%">
      <v-card-actions>
        <h3 class="pa-3 pt-1 pb-1"></h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="showWindow = false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text class="pb-0 px-3">
        <VueCropper
            v-show="selectedFile"
            ref="cropper"
            :src="selectedFile"
            :aspectRatio="1/1"
            :initialAspectRatio="1/1"
        ></VueCropper>
        <v-card-actions class="my-2 px-0">
          <v-btn :disabled="isLoadingProfilePhoto" elevation="0" color="danger" class="white--text" @click="remove"  v-if="user.profile_photo!==null && !selectedFile">{{$t('common.remove')}}</v-btn>
          <v-btn :disabled="isLoadingProfilePhoto" elevation="0" color="primary" @click="$refs.FileInput.click()" >{{$t('common.upload_new_image')}}</v-btn>
          <input
              ref="FileInput"
              type="file"
              style="display: none;"
              @change="onFileSelect"
              :key="componentKey"
          />
          <v-spacer></v-spacer>
          <v-btn :disabled="isLoadingProfilePhoto" elevation="0" color="success" @click="done"  v-if="selectedFile">{{$t('common.done')}}</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import {mapFields} from "vuex-map-fields";
import Reducer from "image-blob-reduce";
export default {
  name: "UserProfilePhotoEditor",
  components: { VueCropper },
  props: {
    show: false,
    user: null,
  },
  data() {
    return {
      componentKey: 0,
      mime_type: '',
      cropedImage: '',
      autoCrop: false,
      selectedFile: null,
      image: '',
    }
  },
  computed:{
    ...mapFields('users', ['isLoadingProfilePhoto']),
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.selectedFile = null;
        this.$emit("hide");
      },
    },
  },
  methods: {
    saveImage(blob) {
      // if(this.user.id) {
      //   this.$store.dispatch('users/setUserProfilePhoto', {'userId': this.user.id, 'blob': blob}).then((response) => {
      //     if (response && response.image || response && response.image === null) {
      //       this.componentKey++;
      //       this.selectedFile = null;
      //       this.$emit("update", response.image);
      //     }
      //   });
      // } else {
        this.$emit("set-image", blob);
      //}
    },
    remove() {
      this.saveImage(null)
    },
    done() {
      this.cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL()
      this.$refs.cropper.getCroppedCanvas().toBlob((image_blob) => {
        const reducer = Reducer();
        reducer
            .toBlob(image_blob, { max: 500 })
            .then(blob => {
              this.saveImage(blob)
            });
      }, this.mime_type)
    },
    onFileSelect(e) {
      const file = e.target.files[0]
      this.mime_type = file.type
      if (typeof FileReader === 'function') {
        this.dialog = true
        const reader = new FileReader()
        reader.onload = (event) => {
          this.selectedFile = event.target.result
          this.$refs.cropper.replace(this.selectedFile)
        }
        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
  },
}
</script>

<style scoped>

</style>